import { Component, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '../../models/field';
import { FieldConfig } from '../../models/field-config';

@Component({
  selector: 'form-input',
  styleUrls: ['./form-input.component.scss'],
  template:`
  <div class="dynamic-field form-input col-12" [formGroup]="group">
    <div class="row">
      <div class="col-3">
        <label>{{ config?.name }} <span *ngIf="config?.validation" style="color: red"> *</span></label>
      </div>
      <div class="col-9">
        <input pInputText type="text" [attr.placeholder]="config?.placeholder" [formControlName]="config?.name" />
      </div>
    </div>
  </div>
    `,
})
export class FormInputComponent implements Field {
  config: FieldConfig;
  group: FormGroup;


}


